import type { TraceEvent, TraceSource } from "../../store/tracing/types";

/** Short, human-legible label for a trace event kind (shared by the Event Log and the cause panel). */
export const TRACE_KIND_LABELS: Record<TraceEvent["kind"], string> = {
    ParameterValueChanged: "Parameter",
    DatasourceRefreshed: "Datasource",
    DatasourceErrorOccurred: "Datasource error",
    FrameDataChanged: "Frame data",
    CanvasStateChanged: "Canvas state",
    DatasourcesInFlightChanged: "Datasources in flight",
    TemplateUpdated: "Template",
};

export function traceKindLabel(kind: TraceEvent["kind"]): string {
    return TRACE_KIND_LABELS[kind] ?? kind;
}

/** Describe where a change originated (e.g. an input control, a datasource binding, page navigation). */
export function traceSourceLabel(source: TraceSource | undefined): string {
    switch (source?.kind) {
        case "DatasourceBinding":
            return `Datasource binding (${source.datasourceName})`;
        case "InputControlChange":
            return "Input control";
        case "ManualUpdate":
            return "Manual update";
        case "InitialLoad":
            return "Initial load";
        case "ParameterValueChanged":
            return "Parameter change";
        case "PageNavigation":
            return "Page navigation";
        case "UpdateParameterValueCall":
            return "updateParameterValue call";
        case "RefreshDatasourceByNameCall":
            return "refreshDatasourceByName call";
        case "DatasourceRequest":
            return "Datasource request";
        case "DatasourceResponse":
            return "Datasource response";
        case "DevTools":
            return "Dev Tools editor";
        case "VsCodeExtension":
            return "VS Code extension";
        default:
            return "—";
    }
}
